export default __webpack_public_path__ + "static/media/default-check-in-container.5f78532f.webp";